export default {"src":"/_next/static/media/seniors.2ded3867.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};